var map = {
	"./blue/mzsm_e_font.svg": "./src/assets/image/blue/mzsm_e_font.svg",
	"./purple/mzsm_e_font.svg": "./src/assets/image/purple/mzsm_e_font.svg",
	"./red/mzsm_e_font.svg": "./src/assets/image/red/mzsm_e_font.svg",
	"./yellow/mzsm_e_font.svg": "./src/assets/image/yellow/mzsm_e_font.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/mzsm_e_font\\.svg$";